import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';

import Button from 'shopper/components/Button';
import Icon from 'shopper/components/Icon';

import { sendEvent } from 'lib/gtag';
import { toOfferRedirectLink } from 'lib/links';
import { getOfferPageEventCategory } from 'lib/offer';

import { useModal } from 'providers/ModalProvider';

import ACTIONS from 'constants/action';

const OfferWithCouponModal = dynamic(() => import('./OfferWithCouponModal'), {
  ssr: false,
});

const GoToStoreButton = forwardRef(
  ({ offerCoupon, offerId, offerStatusName, offerQrCode, utms }, ref) => {
    const { showModal } = useModal();

    if (offerCoupon) {
      return (
        <Button
          ref={ref}
          type="store"
          size="size1"
          iconRight={<Icon name="link-blank" />}
          full
          onClick={() => {
            sendEvent({
              action: 'modal_coupon_open',
              category: 'active_offer_buy',
            });
            showModal(OfferWithCouponModal, {
              isOpen: true,
              offerCoupon,
              offerId,
              offerQrCode,
            });
          }}
        >
          {ACTIONS.GO_TO_STORE}
        </Button>
      );
    }

    return (
      <Button
        ref={ref}
        type="store"
        size="size1"
        as="a"
        target="_blank"
        href={toOfferRedirectLink(offerId, utms)}
        iconRight={<Icon name="link-blank" />}
        full
        onClick={() => {
          sendEvent({
            action: 'go_store',
            category: getOfferPageEventCategory(offerStatusName),
          });
        }}
      >
        {ACTIONS.GO_TO_STORE}
      </Button>
    );
  }
);

GoToStoreButton.displayName = 'GoToStoreButton';

GoToStoreButton.defaultProps = {
  offerCoupon: null,
  offerQrCode: null,
  utms: null,
};

GoToStoreButton.propTypes = {
  offerCoupon: PropTypes.string,
  offerId: PropTypes.number.isRequired,
  offerStatusName: PropTypes.string.isRequired,
  offerQrCode: PropTypes.string,
  utms: PropTypes.string,
};

export default GoToStoreButton;
